/**
 * Top tab strip for {@link CandidRpaStatusModal} (Auth Letter, Documents, Notes).
 *
 * @module candidRpaHeaderNav
 */
import { HorizontalNavigationTab } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useState } from "react";

/** Header tabs shown above the Candid RPA status content. */
export const CANDID_RPA_HEADER_NAV_TABS = [
  {
    label: "Authorizations",
    value: "auth-letter",
  },
  {
    label: "Documents",
    value: "documents",
  },
  {
    label: "Notes",
    value: "notes",
  },
];

/** Tab value for the patient-notes chat list. */
export const CANDID_RPA_NAV_NOTES = "notes";

/** Tab value for the letter PDF / CMM screenshot preview. */
export const CANDID_RPA_NAV_DOCUMENTS = "documents";

/** Tab value for the authorization-card grid. */
export const CANDID_RPA_NAV_AUTH_LETTER = "auth-letter";

/** Props for {@link CandidRpaHeaderNav}. */
interface CandidRpaHeaderNavProps {
  /** Active tab value (`auth-letter` | `documents` | `notes`). */
  selectedNavItem: string;
  /**
   * Notifies the parent when the user selects a tab.
   *
   * @param value - Selected tab value
   */
  onTabChange: (value: string) => void;
}

/**
 * Local-state horizontal nav for switching Candid RPA status views.
 *
 * @param props.selectedNavItem - Active tab value from the parent
 * @param props.onTabChange - Called when the user selects a tab
 * @returns Header tab strip
 */
const CandidRpaHeaderNav = (props: CandidRpaHeaderNavProps) => {
  const [selectedTab, setSelectedTab] = useState<string>("");

  useEffect(() => {
    setSelectedTab(props.selectedNavItem);
  }, [props.selectedNavItem]);

  return (
    <div className="candid-rpa-header-nav">
      <HorizontalNavigationTab
        tabs={CANDID_RPA_HEADER_NAV_TABS}
        value={selectedTab}
        onChange={(value) => {
          setSelectedTab(value);
          props.onTabChange(value);
        }}
        backgroundColor="white"
      />
    </div>
  );
};

export default CandidRpaHeaderNav;
